export default __webpack_public_path__ + "static/media/i043vk.8ccc4d72.webp";